import { find } from 'lodash';

import { if$, strokeSegment } from 'gear';

import { Point, Process, Text } from 'cdl';

import { Tool } from '../view';
import { EmptyPen } from '../../cdl/style';

const updateBrush = function() {
  var brush = this._brush,
      text = this._text;

  this._baseText.brush = brush;

  if (text) {
    text.brush = brush;
    this.view.commit$();
  }
};

const updatePen = function() {
  var pen = this._pen,
      text = this._text;

  this._baseText.pen = pen;

  if (text) {
    text.pen = pen;
    this.view.commit$();
  }
};

export const EditTextTool = Tool.extend({ typeName: 'EditTextTool',

  Properties: {
    pen   : { type: 'Pen'  , def: EmptyPen()  , onChange: updatePen },
    brush : { type: 'Brush', def: Tool.defaultBrush(), onChange: updateBrush }
  },

  type: 'Final',
  toolbarName: 'textTool',

  initTool( view, text, config = {} ) {
    const _this = this;
    _this._cursorOn = true;
    _this.reset();
    _this._baseText = new Text({ text: '',
      brush: _this._brush,
      fontSize: view.viewDeltaToDoc(30), // [TODO] do we want a stable one?
      pen: _this._pen
    });
    const baseTextUpdate = _this._baseText.update$();
    return text ? this.startEdit(text,config.event) : baseTextUpdate;
  },

  reset() {
    const _this = this;
    _this._cursor = null;
    _this._cursorEnd = null;
    _this._center = null;
    _this._currentChar = 0;
    _this._currentLine = 0;
    _this._changed = false;
    _this._text = null;
  },

  link( view ) {
    const _this = this;
    view.cursor = 'text';
    _this._interval = setInterval( () => {
      _this._cursorOn = ! _this._cursorOn;
      _this.view.redraw('tools');
    }, 500);
  },

  unlink( view ) {
    clearInterval( this._interval );
    view.cursor = 'default';
  },

  _commit$( view, doc ) {
    if( ! this._center ) {
      return;
    }
    const text = this._text;
    if( text.isEmpty ) {
      doc.remove(text);
    }
    else {
      view.selectedFigures = [text];
    }
    return doc.commit$();
  },

  _cancel$( view ) {
    return view.revert$();
  },

  canEdit( figure ) {
    return EditTextTool.canEdit(figure);
  },

  startEdit( text, event ) {
    const _this = this, view = _this.view;
    if( _this.canEdit(text) ) {
      _this._text = text;
      _this._center = text.pin;
      return text.update$() .then( () => {
      if( event ) {
        const point = event.docPoint;
        _this.findCurrentChar(point);
      }
      else {
        _this._currentChar = text.lines[0].length;
        _this._currentLine = 0;
      }
      _this.findCursor();
      this.triggerKeyboard(event);
      view.preview$();
      });
    }
    else {
      _this.reset();
      view.fireEvent('textedit',view,text,event);
    }
  },

  on_pointerdown({ event, view, which, docPoint }) {
    const _this = this;
    if$( _this._text && _this._changed, () => {

      const text = _this._text;
      _this.reset();
      if( text.isEmpty ) {
        view.remove(text);
      }
      view.keepSelection();
      return view.commit$();

    }) .then( () => {

    const leftClick = which === 1 ;

    if( leftClick ) {
      const point = docPoint;

      const figure = event.figure; // [EVENTS] view.figureAtPoint(point);
      if( figure && figure.isText ) {
        _this.startEdit(figure,event);
      }
      else {
        _this._text = _this._baseText.clone();
        _this._text.fontSize = view.viewDeltaToDoc(30);
        const center = _this._center = point;
        _this._text.pin = center;
        _this._currentChar = 0;
        _this._currentLine = 0;
        _this._changed = true;
        _this.findCursor();
        this.triggerKeyboard(event);
        view.add(_this._text); // We need a better abstraction here
        view.preview$();
      }
    }
    });
  },

  on_keydown({ event, cmdKey, which }) {

    // console.log('edit text - keydown');

    const _this = this;
    const currentChar = _this._currentChar;
    const currentLine = _this._currentLine;
    const keyHome = which === 36, keyEnd = which === 35;

    if( which === 27 ) {
      event.stopPropagation();
      return this.commit$();
    }

    const figure = _this._text;

    if( ! figure ) {
      return;
    }

    const lines = figure.lines;
    const line = lines[currentLine];

    if( which === 13 ) { // Enter
      event.stopPropagation();

      if( _this._text.isEmpty ) {
        return;
      }

      if( find( figure._processes, p =>
               p instanceof Process.FitOnPath   ||
               p instanceof Process.FitEllipse  ||
               p instanceof Process.ClassicArc  ||
               p instanceof Process.FitEnvelope  ) ) {
        // Do not accept line break
        return;
      }

      _this._changed = true;
      lines[currentLine] = line.slice(0,currentChar);
      lines.splice(currentLine+1,0, "");
      lines[currentLine+1] = line.slice(currentChar);
      figure.lines = lines;
      if( currentChar > 0 ) {
        _this._currentLine++;
        _this._currentChar = 0;
      }
      _this.updateText();
    }
    else if( which === 8 ) { // Backspace
      event.preventDefault();
      if( currentChar > 0 ) {
        _this._changed = true;
        lines[currentLine] = line.slice(0, currentChar-1) + line.slice(currentChar);
        figure.lines = lines;
        _this._currentChar--;
        _this.updateText();
      }
      else if( currentChar === 0 && currentLine > 0 ) {
        _this._changed = true;
        _this._currentChar = lines[currentLine-1].length;
        _this._currentLine--;
        lines[currentLine-1] = lines[currentLine-1]+lines[currentLine];
        lines.splice(currentLine,1);
        figure.lines = lines;
        _this.updateText();
      }
    }
    else if( which === 46 ) { // Delete
      event.stopPropagation();
      if( currentChar < line.length ) {
        _this._changed = true;
        lines[currentLine] = line.slice(0, currentChar) + line.slice(currentChar+1);
        figure.lines = lines;
        _this.updateText();
      }
      else if( currentChar === line.length && currentLine < lines.length ) {
        _this._changed = true;
        lines[currentLine] = lines[currentLine]+lines[currentLine+1];
        lines.splice(currentLine+1,1);
        figure.lines = lines;
        _this.updateText();
      }
    }
    else if( which === 37 || keyHome ) { // Left arrow
      event.stopPropagation();
      if( currentChar > 0 ) {
        if( cmdKey || keyHome ) {
          _this._currentChar = 0;
        }
        else {
          _this._currentChar--;
        }
        _this.updateText();
      }
    }
    else if( which === 39 || keyEnd ) { // Right arrow
      event.stopPropagation();
      if( currentChar < line.length ) {
        if( cmdKey || keyEnd ) {
          _this._currentChar = line.length;
        }
        else {
          _this._currentChar++;
        }
        _this.updateText();
      }
    }
    else if( which === 38 ) { // Up
      event.stopPropagation();
      if( currentLine > 0 ) {
        _this._currentLine--;
        _this._currentChar = Math.floor(lines[_this._currentLine].length/2);
        _this.updateText();
      }
    }
    else if( which === 40 ) { // Down
      event.stopPropagation();
      if( currentLine < lines.length-1 ) {
        _this._currentLine++;
        _this._currentChar = Math.floor(lines[_this._currentLine].length/2);
        _this.updateText();
      }
    }
  },

  on_keypress({ event, which, char }) {
    // console.log('edit text - keypress');
    const _this = this;
    if( ! _this._text ) {
      return;
    }
    event.stopPropagation();
    if( which === 13 ) {
      // We handle Enter on keydown
      return;
    }

    const currentChar = _this._currentChar, currentLine = _this._currentLine;
    const figure = _this._text;
    const lines = figure.lines;

    const line = lines[currentLine];

    _this._changed = true;
    lines[currentLine] = line.slice(0,currentChar) + char + line.slice(currentChar);
    figure.lines = lines;
    _this._currentChar++;

    _this.updateText();
  },

  updateText() {
    const _this = this, view = _this.view, text = _this._text;

    text.update$() .then( () => {
    _this.findCursor();

    view.preview$();
    });
  },

  findCurrentChar( point ) {
    const figure = this._text;
    if( figure.isEmpty ) {
      this._currentChar = 0;
      this._currentLine = 0;
    }
    else {
      const matrix = figure.matrix_(),
            tp = matrix.inverted().apply(point),
            layout = figure._textLayout,
            textLines = layout.textLines();

      let currentChar = 0,
          currentLine = 0,
          minDist = Number.MAX_VALUE;

      for( let kl = 0, klEnd = textLines.length; kl < klEnd; ++kl ) {

        const textLine = textLines[kl],
              lineChars = textLine.allChars(),
              charsLength = lineChars.length;

        if( textLine._chars.length > 0 ) { // there should be at least one proper glyph (do not use _allChars here)
          const dToEnd = Point.distance2(this.closerGlyph(lineChars,charsLength-1)._baselineRightGrip,tp);
          if( dToEnd < minDist ) {
            minDist = dToEnd;
            currentChar = charsLength;
            currentLine = kl;
          }
          for( let kc = 0; kc < charsLength; kc++ ) {
            const char = lineChars[kc];
            if( char ) {
              const d = Point.distance2(char._grip,tp);
              if( d < minDist ) {
                minDist = d;
                currentChar = kc;
                currentLine = kl;
              }
            }
          }
        }
        else {
          const baseDist = Point.distance2(textLine._baseline.P0,tp);
          if( baseDist < minDist ) {
            minDist = baseDist;
            currentChar = 0;
            currentLine = kl;
          }
        }
      }
      this._currentChar = currentChar;
      this._currentLine = currentLine;
    }
  },

  closerGlyph( allChars, pos ) {
    const count = allChars.length;
    let char = allChars[pos],
        n = pos-1;
    while( ! char && n >= 0 ) {
      char = allChars[n--];
    }
    n = pos+1;
    while( ! char && n < count ) {
      char = allChars[n++];
    }
    return char;
  },

  findCursor() {
    const figure = this._text, center = this._center;
    const fontSize = figure.fontSize;
    const matrix = figure.matrix_();
    if( figure.isEmpty ) {
      this._cursor = center;
      this._cursorEnd = matrix.apply( matrix.inverted().apply(center) .plus_(0,fontSize) );
    }
    else {
      const currentChar = this._currentChar;
      const layout = figure._textLayout;
      const line = layout.textLines()[this._currentLine];
      const allChars = line.allChars();
      const bs = line._baseline;
      if( line._chars.length > 0 ) { // If there is a proper glyph
        const char = this.closerGlyph( allChars, currentChar );
        const before = char._originalIdx <= currentChar;
        const grip = before ? char._baselineRightGrip : char._grip;
        const frameDirX = char._frame.dir_x;
        const c = grip .plus( frameDirX .scaled( fontSize/20 * ( before ? 1 : -1 ) ) );
        this._cursor = matrix.apply( c );

        if( figure._processes.length > 0 ) {
          const frame = char._frame;
          const cursorH = ( before ) ? frame.p2 .minus( frame.p1 ) : frame.p3 .minus( frame.p0 );
          this._cursorEnd = matrix.apply( c .plus( cursorH ) );
        }
        else {
          this._cursorEnd = matrix.apply( c .plus( ( bs.P1 .minus( bs.P0 ) ).normalize().perpendicular().sm(fontSize) ) );
        }
      }
      else{
        this._cursor = matrix.apply(bs.P0);
        this._cursorEnd = matrix.apply( bs.P0 .plus( ( bs.P1 .minus( bs.P0 ) ).normalize().perpendicular().sm(fontSize) ) );
      }
    }
    this.view.redraw('tools');
  },

  drawCursorLine( context, transform, lineWidth, strokeStyle ) {
    context.lineWidth = lineWidth;
    context.strokeStyle = strokeStyle;
    strokeSegment( context, this._cursor, this._cursorEnd, transform );
  },

  draw({ view, context, transform }) {
    const center = this._center;
    if( ! center || ! this._cursorOn || ! this._cursor ) {
      return;
    }
    const textureScale = view.viewDeltaToTexture(1);
    this.drawCursorLine(context,transform,3*textureScale,"#dbdbdb");
    this.drawCursorLine(context,transform,1*textureScale,"#248e1f");
  }
});

Tool.Text = Tool.EditText = EditTextTool;

EditTextTool.canEdit = function( figure ) {
  return figure.isText &&
         figure.canBeProcessedLocally() &&
         ! figure.isMultiPart;
};



/** WEBPACK FOOTER **
 ** ./src/ui/tool/edit-text.js
 **/